import api from "./axiox";

export const calculatePrice = async (pricingRequest) => {
  const response = await api.post("/payment/calculate-price", pricingRequest);
  return response.data;
};

export const createOrder = async (order) => {
  const response = await api.post("/payment/create-order", order);
  return response.data;
};

export const createCodOrder = async (order) => {
  const response = await api.post("/payment/create-cod-order", order);
  return response.data;
};

export const verifyPayment = async (payment) => {
  const response = await api.post("/payment/verify-payment", payment);
  return response.data;
};

export const sendPaymentEmail = async (orderId) => {
  const response = await api.post("/payment/send-email", {
    orderId,
  });

  return response.data;
};